import React from "react";
import Layouts from "../Components/Layouts";
import AwardImage from "../Assests/Activities/Award.png";

const Awards = () => {
  return (
    <Layouts>
      <main className="min-h-screen bg-[#FAF8F3] text-gray-800 overflow-x-hidden">

        {/* =====================================================
            HERO SECTION
        ====================================================== */}
        <section className="relative bg-[#FFF1C7] border-b border-[#E5D39C] overflow-hidden">

          {/* Decorative circles */}
          <div className="absolute -top-16 -left-16 sm:-top-24 sm:-left-24 w-32 h-32 sm:w-48 sm:h-48 rounded-full border border-[#D8BD73] opacity-40" />

          <div className="absolute -bottom-20 -right-16 sm:-bottom-28 sm:-right-20 w-40 h-40 sm:w-64 sm:h-64 rounded-full border border-[#D8BD73] opacity-40" />

          <div className="relative w-full max-w-7xl mx-auto px-4 xs:px-5 sm:px-8 lg:px-10 xl:px-12 py-10 sm:py-14 md:py-16 lg:py-20">

            <div className="w-full max-w-4xl mx-auto text-center">

              <span className="inline-block text-[10px] xs:text-xs sm:text-sm font-semibold tracking-[0.22em] xs:tracking-[0.28em] sm:tracking-[0.35em] uppercase text-[#8B6B35]">
                Recognition & Legacy
              </span>

              <h1 className="mt-3 sm:mt-4 text-2xl xs:text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold tracking-wide text-[#5C3A21] leading-[1.15]">
                AWARD & HONOUR
              </h1>

              {/* Divider */}
              <div className="flex items-center justify-center gap-2 sm:gap-3 mt-5 sm:mt-6">
                <div className="w-10 xs:w-14 sm:w-20 md:w-24 h-[2px] bg-[#C79A45]" />

                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rotate-45 bg-[#C79A45]" />

                <div className="w-10 xs:w-14 sm:w-20 md:w-24 h-[2px] bg-[#C79A45]" />
              </div>

              <p className="mt-5 sm:mt-6 max-w-2xl mx-auto text-xs xs:text-sm sm:text-base md:text-lg text-gray-700 leading-6 sm:leading-7 md:leading-8 px-2">
                Honouring a remarkable legacy and recognising the continued
                contribution of the descendants of Sri V. Krishnaswamy Iyer.
              </p>

            </div>
          </div>
        </section>


        {/* =====================================================
            MAIN AWARD SECTION
        ====================================================== */}
        <section className="w-full max-w-7xl mx-auto px-4 xs:px-5 sm:px-8 lg:px-10 xl:px-12 py-12 xs:py-14 sm:py-16 md:py-20 lg:py-24">

          <div className="relative w-full">

            {/* Decorative outer frame */}
            <div className="hidden sm:block absolute -inset-3 lg:-inset-4 rounded-[2rem] border border-[#D9C17B] opacity-50 pointer-events-none" />

            {/* =================================================
                AWARD CARD
            ================================================== */}
            <div className="relative w-full bg-white rounded-2xl sm:rounded-3xl shadow-[0_15px_50px_rgba(92,58,33,0.10)] border border-[#EDE4D4] overflow-hidden">

              <div className="grid grid-cols-1 lg:grid-cols-2">

                {/* =================================================
                    IMAGE SECTION
                ================================================== */}
                <div className="relative w-full bg-[#F2EDE3] flex items-center justify-center p-5 xs:p-6 sm:p-8 md:p-10 lg:p-12 xl:p-14">

                  {/* Inner frame */}
                  <div className="absolute inset-4 xs:inset-5 sm:inset-7 md:inset-8 lg:inset-10 border border-[#D5BA6D] rounded-xl sm:rounded-2xl pointer-events-none" />

                  {/* Corner decorations */}
                  <div className="absolute top-6 left-6 sm:top-8 sm:left-8 md:top-10 md:left-10 w-5 h-5 sm:w-7 sm:h-7 border-t-2 border-l-2 border-[#B18A43]" />

                  <div className="absolute top-6 right-6 sm:top-8 sm:right-8 md:top-10 md:right-10 w-5 h-5 sm:w-7 sm:h-7 border-t-2 border-r-2 border-[#B18A43]" />

                  <div className="absolute bottom-6 left-6 sm:bottom-8 sm:left-8 md:bottom-10 md:left-10 w-5 h-5 sm:w-7 sm:h-7 border-b-2 border-l-2 border-[#B18A43]" />

                  <div className="absolute bottom-6 right-6 sm:bottom-8 sm:right-8 md:bottom-10 md:right-10 w-5 h-5 sm:w-7 sm:h-7 border-b-2 border-r-2 border-[#B18A43]" />

                  {/* IMAGE */}
                  <div className="relative z-10 w-full flex justify-center">

                    <img
                      src={AwardImage}
                      alt="Mr. Shyam Swaminathan Raghunandan receiving the Sri V. Krishnaswamy Iyer Award"
                      className="
                        w-auto
                        max-w-full
                        h-auto
                        max-h-[420px]
                        sm:max-h-[480px]
                        md:max-h-[540px]
                        lg:max-h-[580px]
                        object-contain
                        rounded-lg
                        shadow-lg
                        transition-transform
                        duration-700
                        hover:scale-[1.02]
                      "
                    />

                  </div>

                </div>


                {/* =================================================
                    CONTENT SECTION
                ================================================== */}
                <div className="relative w-full">

                  {/* Background year
                      Hidden on small screens to prevent overlap */}
                  <div className="hidden sm:block absolute top-5 right-6 md:top-8 md:right-8 lg:top-10 lg:right-10 text-[70px] md:text-[100px] lg:text-[125px] xl:text-[145px] font-serif font-bold text-[#F6F0E2] leading-none select-none pointer-events-none">
                    2023
                  </div>


                  <div className="relative z-10 flex flex-col justify-center p-6 xs:p-7 sm:p-9 md:p-11 lg:p-12 xl:p-16">

                    {/* Award label */}
                    <span className="inline-block w-fit text-[10px] xs:text-xs sm:text-sm font-semibold tracking-[0.2em] sm:tracking-[0.3em] uppercase text-[#A17A36]">
                      Sri V. Krishnaswamy Iyer Award
                    </span>


                    {/* PERSON NAME */}
                    <h2 className="
                      mt-3 sm:mt-4
                      text-2xl
                      xs:text-3xl
                      sm:text-4xl
                      md:text-[2.6rem]
                      lg:text-4xl
                      xl:text-5xl
                      font-serif
                      font-bold
                      text-[#4E321F]
                      leading-[1.15]
                      max-w-2xl
                    ">
                      Mr. Shyam Swaminathan Raghunandan
                    </h2>


                    {/* Decorative divider */}
                    <div className="flex items-center gap-3 mt-5 sm:mt-6">

                      <div className="w-12 sm:w-16 h-[3px] bg-[#C79A45]" />

                      <div className="w-2 h-2 sm:w-2.5 sm:h-2.5 rounded-full bg-[#C79A45]" />

                    </div>


                    {/* DATE */}
                    <div className="mt-5 sm:mt-7 inline-flex self-start items-center px-4 sm:px-5 py-2.5 sm:py-3 rounded-full bg-[#FFF4D3] border border-[#E5CC87]">

                      <span className="text-xs sm:text-sm font-bold text-[#6D4B24]">
                        14 December 2023
                      </span>

                    </div>


                    {/* DESCRIPTION */}
                    <div className="mt-6 sm:mt-8 space-y-4 sm:space-y-5">

                      <p className="text-sm xs:text-base sm:text-[17px] lg:text-base xl:text-lg text-gray-700 leading-7 sm:leading-8 text-left sm:text-justify">
                        Mr. Shyam Swaminathan Raghunandan, great-grandson of Sri
                        V. Krishnaswamy Iyer, was felicitated with the{" "}
                        <strong className="text-[#5C3A21]">
                          Sri V. Krishnaswamy Iyer Award
                        </strong>{" "}
                        on December 14, 2023 at Bharathiar Hall, Raj Bhavan by
                        Shri R. N. Ravi, Governor of Tamil Nadu.
                      </p>


                      <p className="text-sm xs:text-base sm:text-[17px] lg:text-base xl:text-lg text-gray-700 leading-7 sm:leading-8 text-left sm:text-justify">
                        The event was organised by{" "}
                        <strong className="text-[#5C3A21]">
                          Gnanavarshini Trust
                        </strong>{" "}
                        as part of the Tamil Nadu Governor’s{" "}
                        <em>“Think to Dare”</em> Lecture and Interaction Series.
                      </p>

                    </div>


                    {/* =================================================
                        EVENT DETAILS
                    ================================================== */}
                    <div className="mt-7 sm:mt-9 grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">

                      {/* Venue */}
                      <div className="rounded-xl sm:rounded-2xl bg-[#FAF7F0] border border-[#E9DFCC] p-4 sm:p-5">

                        <span className="block text-[10px] sm:text-xs uppercase tracking-[0.18em] sm:tracking-[0.2em] text-[#A17A36] font-semibold">
                          Venue
                        </span>

                        <p className="mt-2 text-sm sm:text-base font-semibold text-[#5C3A21]">
                          Bharathiar Hall
                        </p>

                        <p className="text-xs sm:text-sm text-gray-600 mt-1">
                          Raj Bhavan
                        </p>

                      </div>


                      {/* Occasion */}
                      <div className="rounded-xl sm:rounded-2xl bg-[#FAF7F0] border border-[#E9DFCC] p-4 sm:p-5">

                        <span className="block text-[10px] sm:text-xs uppercase tracking-[0.18em] sm:tracking-[0.2em] text-[#A17A36] font-semibold">
                          Occasion
                        </span>

                        <p className="mt-2 text-sm sm:text-base font-semibold text-[#5C3A21]">
                          Think to Dare
                        </p>

                        <p className="text-xs sm:text-sm text-gray-600 mt-1">
                          Lecture & Interaction Series
                        </p>

                      </div>

                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>


        {/* =====================================================
            LEGACY SECTION
        ====================================================== */}
        <section className="relative bg-[#5C3A21] overflow-hidden">

          {/* Decorations */}
          <div className="absolute -top-24 -left-24 sm:-top-32 sm:-left-32 w-48 h-48 sm:w-72 sm:h-72 rounded-full border border-[#D8BD73] opacity-20" />

          <div className="absolute -bottom-28 -right-24 sm:-bottom-40 sm:-right-32 w-64 h-64 sm:w-96 sm:h-96 rounded-full border border-[#D8BD73] opacity-20" />


          <div className="relative w-full max-w-4xl mx-auto px-5 sm:px-8 py-14 sm:py-16 md:py-20 lg:py-24 text-center">

            <span className="text-[10px] xs:text-xs sm:text-sm tracking-[0.25em] sm:tracking-[0.35em] uppercase text-[#E5C978] font-semibold">
              A Continuing Legacy
            </span>

            <h3 className="mt-4 sm:mt-5 text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-white leading-tight">
              Honouring the past.
              <br />
              Inspiring the future.
            </h3>

            <div className="flex items-center justify-center gap-3 mt-6 sm:mt-7">

              <div className="w-10 xs:w-14 sm:w-20 h-[1px] bg-[#D8BD73]" />

              <div className="w-2 h-2 sm:w-2.5 sm:h-2.5 rotate-45 border border-[#D8BD73]" />

              <div className="w-10 xs:w-14 sm:w-20 h-[1px] bg-[#D8BD73]" />

            </div>

            <p className="mt-5 sm:mt-6 text-xs xs:text-sm sm:text-base text-[#E9DDC7] leading-6 sm:leading-7 max-w-2xl mx-auto">
              The Sri V. Krishnaswamy Iyer Award represents a continuing
              connection between a distinguished heritage and the generations
              that carry its values forward.
            </p>

          </div>
        </section>

      </main>
    </Layouts>
  );
};

export default Awards;